// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"304554f6","368":"d20f43c5","447":"a601b3c8","587":"114d173a","629":"feccafed","719":"abb4a90b","828":"677e0bbc","937":"8ea12d8a"}[chunkId] + ".chunk.js";
};